import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__restaurant",
  "use": "icon__restaurant-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__restaurant\"><path fill-rule=\"evenodd\" d=\"M23 18H1a1 1 0 0 1-1-1C0 10.721 4.85 5.562 11 5.051V4a1 1 0 1 1 2 0v1.051c6.15.511 11 5.67 11 11.949a1 1 0 0 1-1 1zM12 7c-5.176 0-9.446 3.954-9.949 9h19.898c-.503-5.046-4.773-9-9.949-9zM1 19h22a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol